export const ITEM_UPLOAD_URL = '/items/new'
export const SIGNUP_URL = '/member/signup/select_type'
export const HOW_IT_WORKS_URL = '/how_it_works'
